module.exports = "<h1>Auto Enrol</h1>\n<h1>{{test}}</h1>"


//////////////////
// WEBPACK FOOTER
// ./src/app/auto_enrol/auto-enrol.component.html
// module id = ./src/app/auto_enrol/auto-enrol.component.html
// module chunks = main